  import axios from "axios";

  // Add a request interceptor
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("_token");
      if (token) {
        config.headers["Authorization"] = token;
      }
      // config.headers["Content-Type"] = "application/json";
      return config;
    },
    (error) => {  
      Promise.reject(error);
    }
  );
